import { render } from "./PartnersLayout.vue?vue&type=template&id=643a0446&ts=true"
import script from "./PartnersLayout.vue?vue&type=script&lang=ts"
export * from "./PartnersLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__